module.exports = __webpack_public_path__ + "2885ebd5248e26b74d31f2d2a44a4bd2.png";